import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './fonts/IBMPlexSans-Regular.ttf';

ReactDOM.render(<App />, document.getElementById('root'));
